export default {
  "A confirmation code has just been sent to you by message": "Se le acaba de enviar un código de confirmación por mensaje",
  "Already have an account": "Ya tienes una cuenta",
  "Beyond this time, the reservation we retain will be available again for others": "Más allá de este tiempo, la reserva que conservamos volverá a estar disponible para otros.",
  "Book now": "Reservar ahora",
  "Booking": "Reserva",
  "Booking information": "Infomación sobre reservas",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "La reserva comienza el primer día a las {startTime} y finaliza el último día a las {endTime}",
  "Cancel booking": "Cancelar reserva",
  "Choose your date": "Elige tu fecha",
  "Confirm my phone number": "Confirmar mi número de teléfono",
  "Confirm my registration": "Confirmar mi registro",
  "Confirm my booking": "Confirmar mi reserva",
  "Confirm my registration and pay": "Confirmar mi registro y pagar",
  "Continue as guest": "Continua como invitado",
  "Continue to registration": "Continuar con el registro",
  "Create an account": "Crea una cuenta",
  "Dates": "fechas",
  "End Date of Reservation": "Fecha de finalización de la reserva",
  "Enlarge map": "Ampliar mapa",
  "Enter your code here to confirm your registration": "Ingresa tu código aquí para confirmar tu registro",
  "I accept the Terms and conditions of registration": "Acepto los Términos y condiciones de registro",
  "I accept the terms of service and confirm that I have read the privacy policy": "Acepto los términos de servicio y confirmo que he leído la política de privacidad",
  "Loading…": "Cargando…",
  "Location": "Ubicación",
  "More information": "Más información",
  "No slots available": "No hay espacios disponibles",
  "Processing booking…": "Procesando reserva…",
  "Processing payment…": "Procesando el pago…",
  "Product": "Producto",
  "Recording payment…": "Registrando pago…",
  "Reduce map": "Reducir mapa",
  "Remaining time": "Tiempo restante",
  "Required fields": "Campos requeridos",
  "Reserving a product is mandatory for registration": "Reservar un producto es obligatorio para el registro.",
  "Retrieving available slots": "Recuperar espacios disponibles",
  "Saving registration…": "Guardando registro…",
  "Select size first": "Seleccione el tamaño primero",
  "Select stage first": "Seleccione la etapa primero",
  "Select your options and dates to book": "Selecciona tus opciones y fechas para reservar",
  "Size": "Tamaño",
  "Slot": "Ranura",
  "Stage": "Escenario",
  "Store": "Tienda",
  "Start Date of Reservation": "Fecha de inicio de la reserva",
  "View privacy policy": "Ver política de privacidad",
  "View terms and conditions": "Ver términos y condiciones",
  "You do not want to create an account": "No deseas crear una cuenta.",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "El producto seleccionado ha sido reservado para ti. Tienes {minutes} minutos para completar el proceso proporcionando tu información personal en la página siguiente.",
  "Your reservation is in progress!": "¡Tu reserva está en proceso!",
  "not available": "No disponible",
  "remaining place": "lugar restante|lugares restantes",
  "see availability": "ver disponibilidad",
  "Email Address": "Correo electrónico",
  "Phone": "Teléfono",
  "Birthdate": "Fecha de nacimiento",
  "ProductTypes": "Tipos de productos",
  "Sizes": "Tallas",
  "Filter": "Filtrar",
  "Select a date": "Selecciona una fecha",
  "Give us your opinion": "Danos tu opinión",
  "Thank you for your review!": "¡Gracias por tu comentario!",
  "You can also review these products": "También puedes revisar estos productos",
  "Undo": "Deshacer",
  "Redo": "Rehacer",
  "Bold": "Negrita",
  "Italic": "Cursiva",
  "Strikethrough": "Tachado",
  "Paragraph": "Párrafo",
  "Add Link": "Añadir enlace",
  "Remove Link": "Quitar enlace",
  "Headings": "Encabezados",
  "Heading 2": "Encabezado 2",
  "Heading 3": "Encabezado 3",
  "Heading 4": "Encabezado 4",
  "Heading 5": "Encabezado 5",
  "Heading 6": "Encabezado 6",
  "Bullet List": "Lista con viñetas",
  "Numbered List": "Lista numerada",
  "Clear Formatting": "Borrar formato",
  "Overall Rating": "Valoración general",
  "Review title": "Título de la reseña",
  "Summarize your impression on the product": "Resume tu impresión sobre el producto",
  "Your detailed product review": "Tu reseña detallada del producto",
  "50 characters minimum": "50 caracteres mínimo",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "¿Cuál fue tu impresión del producto durante la prueba? ¿Qué te gustó o no te gustó del producto? ¿Qué condiciones estaban presentes mientras probabas el producto?",
  "50 characters (minimum)": "50 caracteres (mínimo)",
  "Comments": "Comentarios",
  "Comments on the reception, the organization, the advice on the product…": "Comentarios sobre la recepción, la organización, el consejo sobre el producto…",
  "Would you recommend this product to a friend?": "¿Recomendarías este producto a un amigo?",
  "Would you be ready to buy this product?": "¿Estarías dispuesto a comprar este producto?",
  "First name or pseudo": "Nombre o seudónimo",
  "Your name / nickname is published with your review": "Tu nombre / apodo se publica con tu reseña",
  "I have read and I accept the terms and conditions": "He leído y acepto los términos y condiciones",
  "of publication of the reviews": "de publicación de las reseñas",
  "and": "y",
  "the privacy policy": "la política de privacidad",
  "Post Review": "Publicar reseña",
  "Very bad": "Muy malo",
  "Bad": "Malo",
  "Average": "Promedio",
  "Good": "Bueno",
  "Great!": "¡Genial!",
  "Image caption": "Subtítulo de la imagen",
  "No": "No",
  "Yes": "Sí",
  "This site is protected by reCAPTCHA.": "Este sitio está protegido por reCAPTCHA.",
  "Google Privacy Policy": "Política de Privacidad de Google",
  "Google Terms of Service": "Términos del Servicio de Google",
}
